import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import ArrowDown from '../../../assets/images/ArrowDown.svg'
import Link from '../Link'

const Os1Pricing = (props) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder height="1px" className={styles.gradBorder} />
        {typeof window !== `undefined` && window.innerWidth > 450 && (
          <div>
            <div className={styles.variantNames}>
              {props.subtitle.subtitle
                .trim()
                .split('\n')
                .map((price, idx) => (
                  <div className={styles.variantContainer} key={idx}>
                    <div className={`${styles.variantName} h2`}>
                      {price.split(':')[0]}
                    </div>
                    <div className={styles.variantPrice}>
                      {price.split(':')[1]}
                    </div>
                  </div>
                ))}
            </div>
            <div className={styles.frontImageContainer}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                className={styles.frontImage}
                imgStyle={{ objectFit: 'contain' }}
                alt={props.images[0]?.description}
              />
            </div>

            <div className={styles.ttsContainer}>
              <Link to={props.ctaUrl}>
                <Button className={styles.tts} style={{ width: '304px' }}>
                  {props.ctaText}
                </Button>
              </Link>
              <Link to={props.components[0].ctaUrl} target="_blank">
                <Button
                  className={styles.dl}
                  style={{ width: '304px' }}
                  inverted
                >
                  {props.components[0].ctaText}
                  <ArrowDown
                    style={{
                      display: 'inline',
                      alignSelf: 'center',
                      position: 'relative',
                      left: '10px',
                    }}
                  />
                </Button>
              </Link>
              <div className={styles.volPricingText}>
                <FormattedMessage id="product.pricing" />
              </div>
            </div>
          </div>
        )}
        {typeof window !== `undefined` && window.innerWidth <= 450 && (
          <div>
            <div className={styles.frontImageContainer}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                className={styles.frontImage}
                imgStyle={{ objectFit: 'contain' }}
                alt={props.images[0]?.description}
              />
            </div>

            <div className={styles.variantNames}>
              {props.subtitle.subtitle
                .trim()
                .split('\n')
                .map((price, idx) => (
                  <div className={styles.variantContainer} key={idx}>
                    <div className={`${styles.variantName} h2`}>
                      {price.split(':')[0]}
                    </div>
                    <div className={styles.variantPrice}>
                      {price.split(':')[1]}
                    </div>
                  </div>
                ))}
            </div>
            <div className={styles.ttsContainer}>
              <Link to={props.ctaUrl}>
                <Button className={styles.tts}>{props.ctaText}</Button>
              </Link>
              <Link to={props.components[0].ctaUrl} target="_blank">
                <Button className={styles.dl} inverted>
                  {props.components[0].ctaText}
                  <ArrowDown
                    style={{
                      display: 'inline',
                      alignSelf: 'center',
                      position: 'relative',
                      left: '10px',
                    }}
                  />
                </Button>
              </Link>
              <div className={styles.volPricingText}>
                Volume pricing available
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Os1Pricing
